import { render } from "./SingleVrComponent.vue?vue&type=template&id=7fad88ce"
import script from "./SingleVrComponent.vue?vue&type=script&lang=js"
export * from "./SingleVrComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Desktop/agency-fifty3/wp-content/plugins/af3-shortcodes-plugin-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__